import React from "react";

const CheckboxGroup = ({
  label,
  name,
  values = [],
  checkboxes = [],
  onChange,
  checkboxClass = "",
  videoStyle = false,
}) => {
  return (
    <div>
      {label && (
        <label className="label" htmlFor={name}>
          {label}
        </label>
      )}
      <div
        className={
          videoStyle ? "checkbox-group-list checkbox-group" : "checkbox-group"
        }
      >
        {checkboxes.map((val, i) => {
          const value = typeof val === "object" ? val.value : val;
          const label = typeof val === "object" ? val.label : val;
          return (
            <label key={`${i}${value}`}>
              <input
                name={name}
                type="checkbox"
                value={value}
                className={`checkbox ${checkboxClass}`}
                onChange={onChange}
                checked={values.includes(value)}
              />
              <span aria-label={value}>{label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default CheckboxGroup;
